/**
 * Calendly Configuration API wrapper
 *
 * POST /api/v1/sms/calendly - Configure Calendly integration for a loan officer
 */

import { api } from "../common/utils"
import { CALENDLY_CONFIG_ENDPOINT } from "../common/constants"

export interface CalendlyConfigPayload {
  loid: number
  api_key: string
  scheduling_url: string
}

export interface CalendlyUser {
  avatar_url: string | null
  _id: string
  created_at: string
  current_organization: string
  email: string
  name: string
  resource_type: string
  scheduling_url: string
  slug: string
  timezone: string
  updated_at: string
  uri: string
}

export interface CalendlyConfigResponse {
  _id: string
  api_key: string
  user: CalendlyUser
  loid: number
  webhook_uri: string
  event_type_uri: string
}

const calendlyApi = {
  configure: async (
    payload: CalendlyConfigPayload
  ): Promise<CalendlyConfigResponse> => {
    if (!payload.loid) {
      throw new Error("loid is required")
    }
    if (!payload.api_key) {
      throw new Error("api_key is required")
    }
    if (!payload.scheduling_url) {
      throw new Error("scheduling_url is required")
    }

    const { data } = await api.post(CALENDLY_CONFIG_ENDPOINT, payload)
    return data
  }
}

export default calendlyApi
